<div class="widget__wrap">
    <div class="widget" id="categories-widget">
        <h2 class="widget__header">
            <span class="widget__header__title">
                <i class="widget__header__icon ico-angle-down"></i> Kategorie blogu</span>
            <span class="widget__header__tools">
                <swb-filter-list (modelChange)="filter($event)"></swb-filter-list>
                <a [routerLink]="['categories/add']" class="cta cta--small cta--green">
                    <span class="cta__light">Přidat</span> kategorii
                    <i class="ico-plus"></i>
                </a>
            </span>
        </h2>
        <div class="widget__content">
            <swb-category-list [query]="query"></swb-category-list>
        </div>
    </div>
</div>